import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const me = async () => {
  const res = await httpRequest.get("/prt/auth/me");
  return res;
};

export const me2fa = async () => {
  const res = await httpRequest.get("/2fa/auth/me");
  return res;
};

export type CreatePinDTO = { pin: string };
export const createPin = async (data: CreatePinDTO) => {
  const res = await httpRequest.post("/2fa/auth/pin", data);
  return res;
};

export type UpdatePinDTO = { oldPin?: string; pin: string };
export const updatePin = async (data: UpdatePinDTO) => {
  const res = await httpRequest.put("/2fa/auth/pin", data);
  return res;
};

export type UpdateProfileDTO = {
  registerNo?: string | null;
  familyName?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  phone?: string | null;
  phone2?: string | null;
  email?: string | null;
  email2?: string | null;
};
export const updateProfile = async (data: UpdateProfileDTO) => {
  const res = await httpRequest.put("/prt/auth/profile", data);
  return res;
};

export type UpdateAvatarDTO = { avatar: string };
export const updateAvatar = async (data: UpdateAvatarDTO) => {
  const res = await httpRequest.put("/prt/auth/avatar", data);
  return res;
};

export type ChangePasswordDTO = { oldPassword?: string; password: string };
export const changePassword = async (data: ChangePasswordDTO) => {
  const res = await httpRequest.post("/2fa/auth/password/change", data);
  return res;
};
